export const equipmentState = {
  inspectionRequested: 10,
  inspectionChecklistSelected: 11,
  inspectionPerformed: 14,
  preview: 30,
  auctionInProgress: 31,
  sold: 39,
  auctionResultsVerified: 42,
  paymentDefault: 56,
  returnComplete: 89
}
